/* eslint-disable */
import { brandsAPI } from '../services/api/brands'
import { store as sbStore } from '@springbig/sb-components'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  adRegion: [],
  adSort: null,
  brand: {},
  merchantRequests: [],
  storeErrors: {},
  suggestedTags: [],
  userId: localStorage.getItem('u')
}

export const actions = {
  FETCH_SUGGESTED_TAGS: async function ({ commit }, { advertiserID, page }) {
    try {
      const data = await brandsAPI.fetchSuggestedTags(advertiserID, page)
      commit('SET_SUGGESTED_TAGS', { suggestedTags: data })
    } catch (e) {
      commit('SET_STORE_ERRORS', { errorKey: 'suggestedTags', errorValue: e })
    }
  },

  FETCH_MERCHANT_REQUESTS: async function ({ commit }, { advertiserID, page }) {
    try {
      const data = await brandsAPI.getMerchantRequests(advertiserID, page)
      commit('SET_MERCHANT_REQUESTS', { merchantRequests: data })
    } catch (e) {
      commit('SET_STORE_ERRORS', { errorKey: 'merchantRequests', errorValue: e })
    }
  },

  UPDATE_BRAND: function ({ commit }, { brand }) {
    commit('SET_BRAND', brand)
  },

  UPDATE_AD_SORT: function ({ commit }, { adSort }) {
    commit('UPDATE_AD_SORT', adSort)
  },

  UPDATE_AD_REGION: function ({ commit }, { adRegion }) {
    commit('UPDATE_AD_REGION', adRegion)
  },

  UPDATE_STATE_ITEM: function ({ commit }, { stateKey, stateItem }) {
    commit('SET_STATE_ITEM', { stateKey, stateItem })
  }
}

export const mutations = {
  SET_BRAND: function (state, { brand }) {
    state.brand = { ...brand }
  },

  SET_AD_SORT: function (state, { adSort }) {
    state.adSort = adSort
  },

  SET_AD_REGION: function (state, { adRegion }) {
    state.adRegion = adRegion
  },

  SET_STORE_ERRORS: function (state, { errorKey, errorValue }) {
    state.storeErrors[errorKey] = errorValue
  },

  SET_STATE_ITEM: function (state, { stateKey, stateItem }) {
    state[stateKey] = stateItem
  },

  SET_SUGGESTED_TAGS: function (state, { suggestedTags }) {
    state.suggestedTags = suggestedTags
  },

  SET_MERCHANT_REQUESTS: function (state, { merchantRequests }) {
    state.merchantRequests = merchantRequests
  }
}

export const getters = {
  brandId: function (state) {
    return state.brand.id
  },

  getAdSort: function (state) {
    return state.adSort
  },

  getAdRegion: function (state) {
    return state.adRegion
  },

  hasSuggestedTags: function (state) {
    return state.suggestedTags.length > 0
  }
}

export const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: { sbComponents: sbStore }
})
